export const ProductCategory = {
    LIFE: 1,
    ACCIDENT_HEALTH: 10,
}

export const CLIENT_TYPES = {
    Existing: "Existing",
    Prospect: "Prospect"
}

export const PRODUCT_LIST = {
    Term: "Term Life",
    ABLTC: "Asset-based Long Term Care",
    WL: "Whole Life",
    SPWL: "Single Premium Whole Life",
    UL: "Traditional Universal Life",
    IUL: "Indexed Universal Life",
    VUL: "Variable Universal Life",
    GUL: "Guaranteed Universal Life",
    DI: "Disability",
    FE: "Final Expense",
}

export const PreApptState = ["MI", "PA", "PR", "UT", "WY"];

export const JustInTimeState = ["AL", "AR", "CA", "CT", "DC", "DE", "FL", "GA", "HI", "IA", "ID", "KS", "KY", "LA", "MA", "ME", "MN", "MS", "MT", "NC", "ND", "NE", "NV", "NH", "NJ", "NM", "NY", "OH", "OK", "SC", "SD", "TN", "TX", "VT", "VA", "WA", "WI", "WV"];

export const NoApptState = ["AK", "AZ", "CO", "IL", "IN", "MD", "MO", "OR", "RI"];

export const RadioSelected = {
    yes: 'yes',
    no: 'no',
    TRUE: true,
    FALSE: false
}

export const EmptyString = ''

export const PolicyReviewContact = '844-201-6080'

export const ProductList = {
    BRIGHTHOUSE_SMART_CARE: "SmartCare",
    NATIONWIDE_CARE_MATTERS: "CareMatters",
    NATIONWIDE_CARE_MATTERS_TWO: "CareMatters II",
    NATIONWIDE_CARE_MATTERS_TOGETHER: "CAREMATTERS TOGETHER",
    LINCOLN_MGMA: "MONEYGUARD MARKET ADVANTAGE",
    LINCOLN_MGFA: "MONEYGUARD FIXED ADVANTAGE",
    LINCOLN_MG_II: "MONEYGUARD II",
    LINCOLN_MG_III: "MONEYGUARD III (2021)",
    PAC_LIFE_PREMIER_CARE: "PremierCare",
}

export const EsignerRole = {
    FINANCIAL_ADVISOR: "Financial Advisor",
    PRIMARY_OWNER: "Primary Owner",
    OWNER: "Owner",
    JOINT_OWNER: "Joint Owner",
    PROPOSED_INSURED: "Proposed Insured",
    AUTHORIZED_INDIVIDUAL: "Authorized Individual",
    TRUSTEE: "Trustee"
}

export const OwnerType = {
  PERSON: 'person',
  ORGANIZATION: 'organization'
};

export const AccountTypes = {
    INDIVIDUAL: 'individual',
    JOINT: 'joint',
    TRUST: 'trust',
    CORPORATION: 'corporation',
    UNINCORPORATED: 'unincorporated',
    PARTNERSHIP: 'partnership',
    LIMITED_LIABILITY: 'llc',
    RPM: 'rpm',
    SOLE_PROPRIETOR: "s - sole proprietorship",
}

export const yesNoOptions = [
    { value: 'true', label: "Yes" },
    { value: 'false', label: "No" }
]

export const GenderOptions = [
    { value: 'F', label: 'Female' },
    { value: 'M', label: 'Male' },
]

export const MaritalStatusOptions = [
    { value: "S", label: "Single" },
    { value: "M", label: "Married" },
]

export const TobaccoOptions = [
    { label: 'Have Used in the Last 12 Months', value: 'true' },
    { label: 'Do Not Use Tobacco', value: 'false' },
]

export const CUSTOMER_CODE = 101;

export const OneClickProductType = {
    FullUW: 28,
    MorganStanleyLTCQ: 35,
    MorganStanleyLTCS: 36,
    MorganStanleyULR: 44,
}

export const Regex = {
    OfficeFa : RegExp(/^(?!0{3})\d{3}(-)(?!0{3})\d{3}$/),
    FANum: RegExp(/^(?!0{3})\d{3}$/),
    OfficeAccount : RegExp(/^(?!0{3})\d{3}(-)(?!0{6})\d{6}$/)
}


// WEBPACK FOOTER //
// ./src/components/Common/Constant.js